<div class="kr-currency-conversion" v-if="hasCurrencyConversion"><span class="kr-currency-conversion__label" v-html="label"></span></div>